import React from "react";
import styled from "styled-components";
import { UserRoundCog } from "lucide-react";

const Link = styled.a`
  color: blue;
  cursor: pointer;
  :hover {
    text-decoration: underline;
    color: blue;
  }
`;

const FooterContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 60px;
  padding: 5px 20px;
  width: calc(100% - 60px);
  font-family: Nunito;
  background-color: #fff;
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-6 footer-copyright">
            <p className="mb-0">Copyright {currentYear} © Innen All rights reserved.</p>
          </div>
          <div className="col-md-6 footer-copyright">
            <div className="d-flex justify-content-end align-items-center">
              <UserRoundCog size="20" color="gray" />
              <p className="text-center mb-0">
                Si tenes problemas con la plataforma, hacé{" "}
                <Link target="_blank" href="https://forms.clickup.com/3024895/f/2w9zz-18904/B0OUIKF29BPWW8VS9O">
                  click acá
                </Link>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </FooterContainer>
  );
};

export default Footer;
